<div class="container">
    <div class="row justify-content-center login">
        <div class="col-xl-6 col-lg-6 col-md-9">
            <div class="card o-hidden border-0 shadow-lg my-5">
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-5">
                                <div class="text-center pt-4">
                                    <img src="/assets/images/cronoss_logo.png" width="80%">
                                    <i class="fas fa-history text-primary fa-3x" *ngIf="dw"></i>
                                </div>

                                <div class="text-center pt-4">
                                    <h1 class="h4 text-gray-900 mb-4">{{'common.auth.login.welcome' | translate}}</h1>
                                </div>
                                
                                <form id="loginform" class="user" [formGroup]="loginForm" (ngSubmit)="login()" >
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
                                        <label for="user">{{'entity.user.field.userName.label' | translate}}</label>
                                            <div class="input-group">
                                            <input 
                                                type="text" 
                                                id="userName" 
                                                formControlName="userName" 
                                                (keydown.space)="$event.preventDefault();"
                                                placeholder="{{'entity.user.field.userName.placeHolder' | translate}}" 
                                                class="form-control form-control-user" 
                                            />
                                            <div *ngIf="isSubmitted  && loginForm.controls.userName.errors" class="invalid-feedback d-block">
                                                <div *ngIf="loginForm.controls.userName.errors.required">{{'entity.user.field.userName.invalid' | translate}}</div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
                                            <label for="password">{{'entity.user.field.password.label' | translate}}</label>
                                            <div class="input-group">
                                                <input 
                                                    type="password" 
                                                    id="password" 
                                                    formControlName="password" 
                                                    placeholder="{{'entity.user.field.password.placeHolder' | translate}}" 
                                                    class="form-control form-control-user" 
                                                    aria-describedby="inputGroupPrepend"
                                                    appInputPassword
                                                />
                                            
                                            <div *ngIf="isSubmitted  && loginForm.controls.password.errors" class="invalid-feedback d-block">
                                                <div *ngIf="loginForm.controls.password.errors.required">{{'entity.user.field.password.invalid' | translate}}</div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        {{'common.auth.login.remindMe' | translate}}
                                        <input 
                                            type="checkbox" 
                                            formControlName="keepMeLogged" 
                                            id="keepMeLogged" 
                                        />

                                    </div>
                                    <button id="loginButton" class="btn btn-primary btn-user btn-block" type="submit" [disabled]="loginForm.invalid" #loginButton>
                                        {{'common.auth.login.submit' | translate}}
                                    </button>
                                </form>
                                <hr>
                                <div class="text-center">
                                    <a class="small" routerLink="/forgot-password" routerLinkActive="active">{{'common.auth.login.forgotPassword' | translate}}</a>
                                </div>

                                <div id="invalid-user" *ngIf="errorCode !== ''" class="invalid-feedback  d-block">{{errorCode | translate}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
